import { render, staticRenderFns } from "./Orginforject.vue?vue&type=template&id=ca308bf2&scoped=true"
import script from "./Orginforject.vue?vue&type=script&lang=js"
export * from "./Orginforject.vue?vue&type=script&lang=js"
import style0 from "./Orginforject.vue?vue&type=style&index=0&id=ca308bf2&prod&scoped=true&lang=css"
import style1 from "./Orginforject.vue?vue&type=style&index=1&id=ca308bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca308bf2",
  null
  
)

export default component.exports